// extracted by mini-css-extract-plugin
module.exports = {"root":"Artist_root__33FvZ","rank":"Artist_rank__3pVXA","name":"Artist_name__KXMLc","artwork":"Artist_artwork__LEhT-","info":"Artist_info__3V8iC","genre":"Artist_genre__1sLrT"};